<template>
  <transition name="fade">
    <div
      v-if="valorData"
      ref="unimedcomp__menu"
      :style="estiloDinamicoMenu"
      class="unimedcomp__menu"
    >
      <div
        class="caducomp__menu_items"
        ref="caducomp__menu-items"
        :style="{
          'max-height': `${alturaMaximaMenu}px`
        }"
        @scroll="onScroll"
      >
        <unicom-spinner
          v-if="loading"
          :tamanhoLoading="30"
          :tamanhoLinha="4"
          :velocidade="0.5"
          :marginTopTexto="30"
          style="margin: 20px 0"
        />

        <template v-else>
          <div
            v-for="(item, i) in items"
            v-show="i < limiteItemScrollAtual || (setaIndex && i <= setaIndex)"
            ref="items"
            :key="'caducomp-item-' + i"
            class="unimedcomp__item"
            :class="{
              'unimedcomp__item--selected': selecionaItem(item)
            }"
            @click="noClickSelecionarItem(item, i)"
          >
            <slot :item="item" name="item">
              <span style="position: relative">
                <tooltip-unimed-vue
                  :visualizando="true"
                  :texto="pegaTextoDoItem(item)"
                  :alturaMinima="1"
                  :textoTooltip="pegaMensagemDoItem(item)"
                  :whiteSpaceNoWrap="false"
                  :tooltipLocalizacao="i === 0 ? 'bottom' : 'top'"
                ></tooltip-unimed-vue>
              </span>
            </slot>
          </div>

          <div v-if="!items.length" class="unimedcomp__no-data">
            <slot name="no-data"> Nenhum dado disponível </slot>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import ValorMixin from "./ValorMixin";
import { isObject } from "./helper";

import TooltipUnimedVue from "../Tooltip/TooltipUnimed.vue";

export default {
  mixins: [ValorMixin],
  inject: {
    menuGeral: {
      default: ""
    }
  },
  components: {
    TooltipUnimedVue
  },
  props: {
    largura: {
      type: [String, Number],
      required: false,
      default: 100,
      note: "Largura do Menu"
    },
    altura: {
      type: [String, Number],
      required: false,
      default: 100,
      note: "Altura do Menu."
    },
    alturaMaximaMenu: {
      type: [String, Number],
      required: false,
      default: 120,
      note: "Altura máxima dos itens dentro do menu."
    },
    limiteItemScroll: {
      type: Number,
      default: 20,
      note: "O número limite inical dos itens no menu."
    },
    numeroItemAdicionarScroll: {
      type: Number,
      default: 10,
      note: "Quantidade de itens que são adicionados pelo evento de scroll."
    },
    items: {
      type: Array,
      default: () => [],
      note: "Array que contém os itens que serão mostrado em forma de lista."
    },
    textoDoItem: {
      type: String,
      default: null,
      note: "property in item for text."
    },
    loading: {
      type: Boolean,
      default: false,
      note: "Loading no dropdown."
    },
    valorAtual: {
      type: [String, Number]
    },
    usarTamanhoAutomatico: {
      type: Boolean,
      default: false,
      note: "Usar tamanho automatico do menuItem"
    }
  },
  data() {
    return {
      limiteItemScrollAtual: this.limiteItemScroll,
      setaIndex: null,
      itemSelecionadoSeta: null,
      itemSelecionado: this.valorAtual,
      estiloDinamicoMenu: {}
    };
  },
  mounted() {
    this.$nextTick().then(() => {
      this.criarEstilo();
      window.addEventListener("resize", this.criarEstilo);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.criarEstilo);
  },
  methods: {
    pegaTextoDoItem(item) {
      if (!item) return null;
      if (this.textoDoItem) return item[this.textoDoItem];
      if (isObject(item)) {
        const keys = Object.keys(item);
        if (keys.length === 1) {
          return item[keys[0]];
        }
        return item.descricao;
      }
      return item;
    },
    pegaMensagemDoItem(item) {
      if (!item) return null;
      if (this.textoDoItem) return item[this.textoDoItem];
      if (isObject(item)) {
        const keys = Object.keys(item);
        if (keys.length === 1) {
          return item[keys[0]];
        }
        return item.mensagem;
      }
      return item;
    },
    noClickSelecionarItem(item, i) {
      this.itemSelecionado = this.pegaTextoDoItem(item);
      this.$emit("input", false);
      this.$emit("indexLista", i);
      this.eventoValor(this.pegaTextoDoItem(item));
      let index = this.items.findIndex(el => el === item);
      this.$emit("index", index);
    },
    selecionaItem(item) {
      return (
        item === this.itemSelecionadoSeta ||
        (item === this.itemSelecionado && !this.itemSelecionadoSeta)
      );
    },
    onScroll(event) {
      if (this.limiteItemScrollAtual >= this.items.length) return;

      const content = event.target;
      const showMoreItems =
        content.scrollHeight - (content.scrollTop + content.clientHeight) < 200;

      if (showMoreItems) {
        this.limiteItemScrollAtual += this.numeroItemAdicionarScroll;
      }
    },
    eventoValor(item) {
      this.itemSelecionadoSeta = null;
      this.$nextTick(() => {
        this.$emit("select", item);
      });
    },
    criarEstilo() {
      if (this.largura !== 100) {
        this.estiloDinamicoMenu = {
          width: this.largura + "%",
          left: this.altura + "px"
        };
      } else {
        let largura = this.menuGeral.instance.$el.offsetWidth;

        if (largura === 0) return;

        this.estiloDinamicoMenu = {
          width: largura + "px",
          left: this.altura + "px"
        };
      }
    }
  },
  watch: {
    valorAtual() {
      this.itemSelecionado = [null, undefined, ""].includes(this.valorAtual)
        ? ""
        : this.valorAtual;
    }
  }
};
</script>

<style lang="scss">
@import "./MenuItem.scss";
</style>
